import React from 'react';
import { Button } from '../ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { CheckCircle2 } from 'lucide-react';

export function BulkSettlementBar({
  pendingCount, pendingTotal,
  settleOpen, setSettleOpen,
  settling, onSettle,
}) {
  if (pendingCount <= 0) return null;
  return (
    <>
      <div className="flex items-center justify-between gap-3 px-4 py-3 rounded-xl bg-amber-50 border border-amber-200" data-testid="settle-bar">
        <p className="text-sm text-amber-800">
          <span className="font-semibold">{pendingCount}</span> booking{pendingCount !== 1 ? 's' : ''} with pending payment
          {' '}(<span className="font-semibold">₹{pendingTotal.toLocaleString('en-IN')}</span>) in the current view
        </p>
        <Button
          onClick={() => setSettleOpen(true)}
          className="bg-emerald-600 hover:bg-emerald-700 shrink-0"
          data-testid="mark-all-paid-button"
        >
          <CheckCircle2 className="w-4 h-4 mr-1.5" />
          Mark All Pending as Paid
        </Button>
      </div>

      <AlertDialog open={settleOpen} onOpenChange={setSettleOpen}>
        <AlertDialogContent data-testid="settle-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Mark all pending payments as paid?</AlertDialogTitle>
            <AlertDialogDescription>
              This will mark <span className="font-semibold text-slate-900">{pendingCount}</span> booking{pendingCount !== 1 ? 's' : ''} (totalling <span className="font-semibold text-slate-900">₹{pendingTotal.toLocaleString('en-IN')}</span>) in the current filtered view as fully paid. Bookings with no pending amount are ignored. This cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="settle-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onSettle} disabled={settling} className="bg-emerald-600 hover:bg-emerald-700" data-testid="settle-confirm">
              {settling ? 'Settling…' : 'Confirm & Mark Paid'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
